import {
  toCharArray32huqyw9tt7kx as toCharArray,
  decodeToString1x4faah2liw2p as decodeToString,
} from '../../../../kotlin-kotlin-stdlib/kotlin/text/stringJs.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { createThis2j2avj17cvnv2 as createThis } from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  copyOfRange3alro60z4hhf8 as copyOfRange,
  contentEquals1cdp6c846cfdi as contentEquals,
  contentHashCode25jw6rgkgywwr as contentHashCode,
} from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_ArraysJs.mjs';
import { getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { IndexOutOfBoundsException1qfr429iumro0 as IndexOutOfBoundsException } from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  _UByte___init__impl__g9hnc430zp6cgd9f0jq as _UByte___init__impl__g9hnc4,
  _UByte___get_data__impl__jof9qryxuf3cmdpzyk as _UByte___get_data__impl__jof9qr,
} from '../../../../kotlin-kotlin-stdlib/kotlin/UByte.mjs';
import { compareTo3ankvs086tmwq as compareTo } from '../../../../kotlin-kotlin-stdlib/kotlin/js/compareTo.mjs';
import { StringBuildermazzzhj6kkai as StringBuilder } from '../../../../kotlin-kotlin-stdlib/kotlin/text/StringBuilderJs.mjs';
import { _Char___init__impl__6a9atx2yltdocdrxs4d as _Char___init__impl__6a9atx } from '../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { Comparable198qfk8pnblz0 as Comparable } from '../../../../kotlin-kotlin-stdlib/kotlin/Comparable.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        this.w4e_1 = ByteString().a4f(new Int8Array(0), null);
        this.x4e_1 = toCharArray('0123456789abcdef');
      }
      b4f(byteArray) {
        return ByteString().a4f(byteArray, null);
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var ByteStringClass;
function ByteString() {
  if (ByteStringClass === VOID) {
    class $ {
      constructor(data, dummy) {
        return new.target.a4f(data, dummy);
      }
      static a4f(data, dummy) {
        Companion_getInstance();
        var $this = createThis(this);
        $this.y4e_1 = data;
        $this.z4e_1 = 0;
        return $this;
      }
      static c4f(data, startIndex, endIndex) {
        Companion_getInstance();
        startIndex = startIndex === VOID ? 0 : startIndex;
        endIndex = endIndex === VOID ? data.length : endIndex;
        return this.a4f(copyOfRange(data, startIndex, endIndex), null);
      }
      q2() {
        return this.y4e_1.length;
      }
      equals(other) {
        if (this === other)
          return true;
        if (other == null || !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
          return false;
        if (!(other instanceof ByteString()))
          THROW_CCE();
        if (!(other.y4e_1.length === this.y4e_1.length))
          return false;
        if (!(other.z4e_1 === 0) && !(this.z4e_1 === 0) && !(other.z4e_1 === this.z4e_1))
          return false;
        return contentEquals(this.y4e_1, other.y4e_1);
      }
      hashCode() {
        var hc = this.z4e_1;
        if (hc === 0) {
          hc = contentHashCode(this.y4e_1);
          this.z4e_1 = hc;
        }
        return hc;
      }
      r2(index) {
        if (index < 0 || index >= this.q2())
          throw IndexOutOfBoundsException().i3('index (' + index + ') is out of byte string bounds: [0..' + this.q2() + ')');
        return this.y4e_1[index];
      }
      x2w(startIndex, endIndex) {
        var tmp;
        if (startIndex === endIndex) {
          tmp = Companion_getInstance().w4e_1;
        } else {
          tmp = ByteString().c4f(this.y4e_1, startIndex, endIndex);
        }
        return tmp;
      }
      d4f(startIndex, endIndex, $super) {
        endIndex = endIndex === VOID ? this.q2() : endIndex;
        return $super === VOID ? this.x2w(startIndex, endIndex) : $super.x2w.call(this, startIndex, endIndex);
      }
      e4f(other) {
        if (other === this)
          return 0;
        var localData = this.y4e_1;
        var otherData = other.y4e_1;
        var inductionVariable = 0;
        var tmp0 = this.q2();
        // Inline function 'kotlin.math.min' call
        var b = other.q2();
        var last = Math.min(tmp0, b);
        if (inductionVariable < last)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            // Inline function 'kotlin.toUByte' call
            var this_0 = localData[i];
            var tmp0_0 = _UByte___init__impl__g9hnc4(this_0);
            // Inline function 'kotlin.toUByte' call
            var this_1 = otherData[i];
            // Inline function 'kotlin.UByte.compareTo' call
            var other_0 = _UByte___init__impl__g9hnc4(this_1);
            // Inline function 'kotlin.UByte.toInt' call
            var tmp = _UByte___get_data__impl__jof9qr(tmp0_0) & 255;
            // Inline function 'kotlin.UByte.toInt' call
            var tmp$ret$5 = _UByte___get_data__impl__jof9qr(other_0) & 255;
            var cmp = compareTo(tmp, tmp$ret$5);
            if (!(cmp === 0))
              return cmp;
          }
           while (inductionVariable < last);
        return compareTo(this.q2(), other.q2());
      }
      d(other) {
        return this.e4f(other instanceof ByteString() ? other : THROW_CCE());
      }
      toString() {
        if (isEmpty(this)) {
          return 'ByteString(size=0)';
        }
        var sizeStr = this.q2().toString();
        var len = (22 + sizeStr.length | 0) + imul(this.q2(), 2) | 0;
        // Inline function 'kotlin.with' call
        var $this$with = StringBuilder().ub(len);
        $this$with.m1('ByteString(size=');
        $this$with.m1(sizeStr);
        $this$with.m1(' hex=');
        var localData = this.y4e_1;
        var inductionVariable = 0;
        var last = this.q2();
        if (inductionVariable < last)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var b = localData[i];
            $this$with.o1(Companion_getInstance().x4e_1[(b >>> 4 | 0) & 15]);
            $this$with.o1(Companion_getInstance().x4e_1[b & 15]);
          }
           while (inductionVariable < last);
        return $this$with.o1(_Char___init__impl__6a9atx(41)).toString();
      }
      f4f() {
        return this.y4e_1;
      }
    }
    initMetadataForClass($, 'ByteString', VOID, VOID, [Comparable()]);
    ByteStringClass = $;
  }
  return ByteStringClass;
}
function ByteString_0(bytes) {
  var tmp;
  // Inline function 'kotlin.collections.isEmpty' call
  if (bytes.length === 0) {
    tmp = Companion_getInstance().w4e_1;
  } else {
    tmp = Companion_getInstance().b4f(bytes);
  }
  return tmp;
}
function decodeToString_0(_this__u8e3s4) {
  return decodeToString(_this__u8e3s4.f4f());
}
function isEmpty(_this__u8e3s4) {
  return _this__u8e3s4.q2() === 0;
}
//region block: exports
export {
  Companion_getInstance as Companion_getInstance36v07euvaglly,
  ByteString_0 as ByteString3c9fk8lsh3lvs,
  ByteString as ByteString10sanmoo66key,
  decodeToString_0 as decodeToString2ede220pr5xir,
};
//endregion

//# sourceMappingURL=ByteString.mjs.map
